import { render, staticRenderFns } from "./classDialog.vue?vue&type=template&id=5a6a629e&"
import script from "./classDialog.vue?vue&type=script&lang=js&"
export * from "./classDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports